import React,{Component} from 'react';
import {Link} from 'react-router-dom';

import {Header} from '../header/Header';
import {Footer} from '../footer/Footer';


export class Tenders extends Component{
    constructor(){
        super();
    }

    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
            <div className="container">
                <h2 className="text-center">Tenders</h2>
                <br/>
                <ul>
                <li><Link to="/tender-notice">TENDER NOTICE FOR HIRING OF JANITORIAL SERVICES, 
                  HIRING OF SECURITY SERVICES & INSTALLATION OF CCTV SYSTEM FOR 
                  SECURITY MEASURES, DEVELOPMENT OF SOFTWARE/HARDWARE, 
                  HIRING OF EXAMINATION CENTER EQUIPMENTS & ACCESSORIES(FURNITURES), 
                  PRINTING OF PRICED FORMS/NON PRICED FORMS & ENVELOPES, 
                  ETC, PROCUREMENT OF COMPUTERS & I.T RELATED ITEMS AND 
                  PROCUREMENT OF COMPUTER STATIONERY. 12-11-2018 ( N E W )</Link></li>
                <li><a href="#">Request for Quotation for Generator Servicing 30-10-2018 ( N E W)</a></li>
               <li> <a href="#">Request for Quotation for the Printing of Miscellaneous Items ( N E W )</a></li>
                <li><a href="#">Request for Quotation for the supply of Plastic Bags (New)</a></li>
                <li><a href="#">Request for Quotations for the repair & renovation of room</a></li>
                <li><a href="#">Request for Quotation for the Repairing work of Roof</a></li>
                <li><a href="#">Request for Quotation for the repairing of confernce table</a></li>
                <li><a href="#">Request for quotation for Modidication & Shifting of CCTV System with Fiber Optic</a></li>
                <li><a href="#">Tender Notice for Procurement of Computers, Printers & Accessories and Supply of Sports Goods</a></li>
                <li><a href="#">SBD Computers, Printers and Accessories</a></li>
                <li><a href="#">SBD Sports Goods</a></li>
                <li><a href="#">Request for Quotation for the supply of LED TV</a></li>
                </ul>
                <br/>
                <h3 className="text-center">Tender for Printing of Examination Sensitive Material</h3>
                <br/>
                <ul>
               <li> <a href="#">Technical Proposal --- Financial Proposal</a></li>
               <li> <a href="#">Tender for Stationary and Consumable articles 2017-2018</a></li>
              <li>  <a href="#">Tender Notice for the Supply of Liveries</a></li>
               <li> <a href="#">NIT of tenders</a></li>
               <li> <a href="#">Tender Notice for Hiring of Furniture 2018</a></li>
               <li> <a href="#">Tender Notice for Office Furniture</a></li>
               <li> <a href="#">Tender Notice for the supply of Plastic Bags</a></li>
               <li> <a href="#">Tender Notice for Repair and Maintenance of Generator</a></li>
               <li> <a href="#">NIT - Procurement of Biometric Attendance Machine and PABX System</a></li>
               <li> <a href="#">Publication of Evaluation Report for the Supply of Different Educational Credentials SR#30888</a></li>
               <li> <a href="#">Re-Tender Notice for Hiring of Security Services</a></li>
              <li>  <a href="#">Tender Notice For Supply of Heavy Duty Color Printers</a></li>
               <li> <a href="#">Tender Notice Staionary and Consumable Articles</a></li>
                </ul>
                <br/>
                <h3 className="text-center">YEAR 2016</h3>
                <br/>
                <ul>
               <li> <a href="#">Tender Notice For Disposal of Used Answer Scripts, Newspapers and Waste Paper Etc</a></li>
               <li> <a href="#">Tender Notice for Hiring of Examination Centers Equipment Accessories</a></li>
               <li> <a href="#">Tender Notice for Stationary And Consumables Items</a></li>
               <li> <a href="#">Tender Notice for Disposal of Used Answer Scripts, News Papers & Waster Papers Etc.</a></li>
                </ul>
                <br/>
                <h3 className="text-center">YEAR 2014</h3>
                <ul>
               <li> <a href="#">Tender Notice for Supply of Sports Goods</a></li>
               <li> <a href="#">Award of Contract For Supply Of Different Educational Credential</a></li>
               <li> <a href="#">Bid Evaluation Report</a></li>
               <li> <a href="#">Tender Document Notification, Technical Bid for Printing</a></li>
               <li> <a href="#">Invitation of Bids - Supply of Different Educational Credentials</a></li>
               <li> <a href="#">Bid Evaluation Report - Supply of Sport Goods</a></li>
               <li> <a href="#">Tender Notice for Hiring of Examination Centers Equipment Accessories</a></li>
               <li> <a href="#">Experssion of Interest (Civil Works)</a></li>
               <li> <a href="#">Tender Notice For For Supply of Sport's GoodsTender Notice For Disposal of Used Answer Scripts, NewsPapers & Waste Papers Etc</a></li>
               <li> <a href="#">Tender Notice For Stationary & Consumables Articles</a></li>
                </ul>
                <br/>
                <hr/>
                <br/>
                <ul>
               <li> <a href="#">Bid Evaluation Report</a></li>
               <li> <a href="#">Tender - Notice For Hiring of Examination Centers Equipment Accessories</a></li>
               <li> <a href="#">BID EVALUATION REPORT SUPPLY OF STATIONARY ADN CONSUMABLE ARTICLES</a></li>
               <li> <a href="#">TENDER NOTICE FOR DISPOSAL FOR USED ANSWER SCRIPTS</a></li>
               <li> <a href="#">Tender's Publication, Stationary & Consumable Articles</a></li>
               <li> <a href="#">Tender's Publication, Tender's Notice</a></li>
               <li> <a href="#">Evaluation Report - Tender For Disposal of Used Answer Scripts, News Paper</a></li>
               <li> <a href="#">Evaluation Report - Tender For Supply of Stationary and Consumable Articles</a></li>
               <li> <a href="#">TENDER NOTICE - STATIONARY AND CONSUMABLE ARTICLES</a></li>
               <li> <a href="#">TENDER NOTICE FOR DISPOSAL OF USED ANSWER SCRIPTS, NEWS PAPERS AND WASTE PAPERS ETC</a></li>
               <li> <a href="#">EVALUATION RESULTS</a></li>
               <li> <a href="#">TENDER FOR SUPPLY OF OFFICE FURNITURE</a></li>
               <li> <a href="#">INVITATION OF BIDS SUPPLY OF DIFFERENT EDUCATIONAL CREDENTIALS</a></li>
               <li> <a href="#">TENDER NOTICE OF SUPPLY OF OFFICE FURNITURE</a></li>
               <li> <a href="#">EVALUATION REPORT FOR HIRING OF EXAMINATION CENTERS EQUIPMENT & ACCESSORIES</a></li>
               <li> <a href="#">EVALUATION REPORT SUPPLY OF WINTER & SUMMER UNIFORMS</a></li>
               <li> <a href="#">EVALUATION REPORT OF PURCHASE & SUPPLY OF STATIONARY AND CONSULMABLES ARTICLES</a></li>
               <li> <a href="#">EVALUATION REPORT OF COMPUTER HARDWARE TENDER</a></li>
               <li> <a href="#">INVITATION FOR BIDS</a></li>
               <li> <a href="#">TENDER NOTICE FOR DISPOSAL FOR USED ANSWER SCRIPTS</a></li>
               <li> <a href="#">TENDER NOTICE FOR COMPUTER HARDWARE, SCANNERS, PRINTERS</a></li>
               <li> <a href="#">EVALUATION REPORT-TENDER FOR SUPPLY OF SPORTS GOODS</a></li>
               <li> <a href="#">TENDER NOTICE FOR SOUND UNIFORM MANUFACTURERS</a></li>
               <li> <a href="#">EVALUATION REPORT OF THE TENDER NOTICE FOR THE SUPPLY OF DUPLICATING PAPER</a></li>
               <li> <a href="#">TENDER NOTICE FOR THE SUPPLY OF DUPLICATING PAPER</a></li>
               <li> <a href="#">TENDER NOTICE FOR THE SUPPLY OF SPORTS GOODS</a></li>
               <li> <a href="#">TENDER NOTICE FOR PREPARATION OF GOLD PLATED, SILVER & BRONZE MEDALS</a></li>
               <li> <a href="#">EVALUATION REPORT </a></li>
               <li> <a href="#">TENDER OF SUPPLY OF SUMMER UNIFORM</a></li>
               <li> <a href="#">EVALUATION REPORT </a></li>
               <li> <a href="#">TENDER OF HIRING OF EXAMINATIONS CENTER FURNITURES'S 2011</a></li>
               <li> <a href="#">TENDER OF SOFTWARE: </a></li>
               <li> <a href="#">Automation of Enrolment, Certificate with Integration of Examination System</a></li>
               <li> <a href="#">TENDER NOTICE STATIONARY AND CONSUMABLES ARTICLES</a></li>
               <li> <a href="#">EVALUATION REPORTS OF SUPPLY OF SPORT GOODS</a></li>
               <li> <a href="#">EVALUATION REPORTS OF CONSUMABLES ARTICLES</a></li>
               <li> <a href="#">TENDER NOTICE FOR UNIFORM MANUFACTURERS</a></li>
               <li> <a href="#">TENDER NOTICE FOR DISPOSAL OF USED ANSWER SCRIPTS NEWS PAPERS & WASTE PAPERS ETC</a></li>
               <li> <a href="#">TENDER NOTICE FOR THE PRERATION OF GOLD PLATED, SILVER & BRONZE MEDALS</a></li>
               <li> <a href="#">EVALUATION REPORTS OF ANSWER SCRIPTS, NEWSPAPERS AND WASTE PAPERS</a></li>
               <li> <a href="#">TENDER NOTICE FOR HIRING OF FURNITURE FOR EXAMINATION CENTERS</a></li>
                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}